import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CartService } from "../../Services/cart.service";
import { CartOffLineService } from "../../Services/cartOffline.service";
import { AccountService } from "../../Services/account.service";
import { map, pluck, switchMap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { CartProduct } from "../../Models/cart-product";
import { Client } from "src/app/Models/client";
import { StorageService } from "../../Services/storage.service";

@Component({
    selector: "app-header-cart",
    templateUrl: "./header-cart.component.html",
    styleUrls: ["./header-cart.component.scss"],
    standalone: false
})
export class HeaderCartComponent implements OnInit {
  cartProductCount = 0;
  total = 0;

  client?: Client | null = null;

  constructor(
    private storage: StorageService,
    private accountService: AccountService,
    private cartService: CartService,
    private cartOffLineService: CartOffLineService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.accountService.accountSubject.subscribe((client) => {
      this.client = client;
      if (client) {
        this.getCartOnLine();
      } else {
        this.getCartOffLine();
      }
    });
  }

  getCartOnLine() {
    let localItems = 0;
    const length = this.cartOffLineService.cartProducts.length;
    this.cartOffLineService.cartProducts.forEach((po: CartProduct) => {
      localItems++;
      this.cartService.add(po.configuration!, po.quantity!).subscribe(() => {});
      if (localItems === length) {
        this.storage.removeItem("carts");
        // this.cartOffLineService.removeAll();
      }
    });
    this.cartService.cart.subscribe((e) => {
      this.cartProductCount = e.length;
      this.total = 0;
      e.forEach((c) => {
        if (
          c.configuration?.discount &&
          new Date() >= new Date(c.configuration.discount.startingDate) &&
          new Date() <= new Date(c.configuration.discount.endingDate)
        ) {
          this.total =
            this.total +
            c.quantity! *
              c.configuration.price! *
              (1 - c.configuration.discount.value / 100);
        } else {
          this.total = this.total + c.quantity! * c.configuration?.price!;
        }
      });
    });
  }
  getCartOffLine() {
    this.cartOffLineService.cart.subscribe((res) => {
      this.total = 0;
      // @ts-ignore
      this.cartProductCount = res.CartProduct.length;
      // @ts-ignore
      res.CartProduct.forEach((c) => {
        if (
          c.configuration?.discount &&
          new Date() >= new Date(c.configuration.discount.startingDate) &&
          new Date() <= new Date(c.configuration.discount.endingDate)
        ) {
          this.total =
            this.total +
            c.quantity! *
              c.configuration.price! *
              (1 - c.configuration.discount.value / 100);
        } else {
          this.total = this.total + c.quantity! * c.configuration?.price!;
        }
      });
    });
  }

  goToCartCheckout() {
    this.router.navigate(["cart"]);
  }
}
